import httpService from "./httpService";

export default {
    getAll: async () => {
        return await httpService.get('default-settings');
    },
};
